import { render, staticRenderFns } from "./BioBreak.vue?vue&type=template&id=5d4fc2a2&"
import script from "./BioBreak.vue?vue&type=script&lang=js&"
export * from "./BioBreak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports